<script>
  import $ from 'jquery'
  import _ from 'underscore'
  import { mapGetters } from 'vuex'

  const domEventNS = 'ItemPage'

  export default {
    components: {},
    props: {
      title: String,
      date : String,
      items: Array,
      narrowCols: Array,
    },

    data () {
      return {
      }
    },

    computed: {
      ...mapGetters({
        'userIsLoggedIn': 'user/isLoggedIn',
      }),
    },

    watch: {
    },

    created () {
    },

    mounted () {
      this.autoResize()
      $(window).on(`resize.${domEventNS}`, () => this.autoResize())
    },

    beforeDestroy () {
      $(window).off(`.${domEventNS}`)
    },

    methods: {
      autoResize () {
        const $el = $(this.$el)

        // 1カラムの表示に必要な最低幅を取得。
        // CSS の min-width 指定値を取得→実数化 (単位px)
        const cssMinWidth = $el.css('min-width')
        const minWidth = cssMinWidth.endsWith('px') ? parseFloat(cssMinWidth) : 0

        // CSS Transform の新しい scale 値を算出。
        // 最大値は 1 。min-width 値が viewport 幅より広いとき、scale は 1 未満となる。
        const scale = Math.min(1, window.innerWidth / minWidth)
        $el.css('transform', `scale(${scale})`)

        return this
      },

      storeItems () {
        const items = this.items.filter(item => !!item.name)  // プレースホルダ項目は除外
        this.$store.dispatch('user/updateStoredItems', items)
      },

      colModifier (colNum) {
        const modifiers = []

        // props "narrowCols" の内容を精査し、1以上の正数しか入ってない状態を保証する
        const narrowCols = _
          .chain(this.narrowCols)
          .map(num => Number(num))
          .filter(num => (num > 0))
          .value()

        if (narrowCols.includes(colNum)) {
          modifiers.push('-narrow')
        }

        return modifiers
      }
    },

    filters: {
    },
  }
</script>


<template>
  <section class="Page">
    <header class="Page__title">
      <router-link to="/" rel="home"><img src="../assets/satomin.png" alt="Home" /></router-link>
      <h1><slot name="title"></slot></h1>
      <button v-if="userIsLoggedIn" @click="storeItems()">SAVE</button>
    </header>
    <div class="Page__body">
      <div class="Page__col" :class="colModifier(1)"><slot name="col1"></slot></div>
      <div class="Page__col" :class="colModifier(2)"><slot name="col2"></slot></div>
      <div class="Page__col" :class="colModifier(3)"><slot name="col3"></slot></div>
      <div class="Page__col" :class="colModifier(4)"><slot name="col4"></slot></div>
      <div class="Page__col" :class="colModifier(5)"><slot name="col5"></slot></div>
      <div class="Page__col" :class="colModifier(6)"><slot name="col6"></slot></div>
      <div class="Page__col" :class="colModifier(7)"><slot name="col7"></slot></div>
      <div class="Page__col" :class="colModifier(8)"><slot name="col8"></slot></div>
      <div class="Page__col" :class="colModifier(9)"><slot name="col9"></slot></div>
      <div class="Page__col" :class="colModifier(10)"><slot name="col10"></slot></div>
      <div class="Page__col" :class="colModifier(11)"><slot name="col11"></slot></div>
      <div class="Page__col" :class="colModifier(12)"><slot name="col12"></slot></div>
      <div class="Page__col" :class="colModifier(13)"><slot name="col13"></slot></div>
      <div class="Page__col" :class="colModifier(14)"><slot name="col14"></slot></div>
      <div class="Page__col" :class="colModifier(15)"><slot name="col15"></slot></div>
      <div class="Page__col" :class="colModifier(16)"><slot name="col16"></slot></div>
      <div class="Page__col" :class="colModifier(17)"><slot name="col17"></slot></div>
      <div class="Page__col" :class="colModifier(18)"><slot name="col18"></slot></div>
      <div class="Page__col" :class="colModifier(19)"><slot name="col19"></slot></div>
      <div class="Page__col" :class="colModifier(20)"><slot name="col20"></slot></div>
    </div>
  </section>
</template>


<style lang="scss" scoped>
  @import url(//fonts.googleapis.com/css?family=M+PLUS+Rounded+1c);
  @import '~@/stylesheets/common';

  .Page {
    $spacing--pc: $size-unit * 10;
    $spacing--sp: $size-unit * 5;
    $col-width: $item-width * $items-per-col - $item-padding * ($items-per-col - 1);
    $min-width: $col-width + $spacing--sp * 2;

    & {
      @include iroha-font-smoothing(off);

      // autoResize 処理関連
      position: absolute;          // scale による縮小で親要素に余白が生じるのを回避
      transform: none;             // style 属性値に縮小のみの scale が設定される（JS 側処理）
      transform-origin: top left;  // 初期値は center だからこうしないとダメ
      min-width: $min-width;       // 1カラムの表示に必要な最低幅（px 値で指定, JS 側処理に必要）

      min-width: 100%;
      min-height: 100%;

      box-sizing: border-box;
      margin: 0;
      padding: 0;
      font-family: $font-family--default;

      // 公式サイト2年目の背景画像を使用
      // background-image: url(../assets/bg_01.png);
      // background-position: center;
      // background-repeat: no-repeat;
      // background-size: cover;

      // 公式サイト1年目の背景画像を使用
      background-image: url(../assets/bg_03.png);
      background-position: center;
      background-repeat: repeat;
      &::before {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: hsla(330, 25, 70, 0.35);
        // backdrop-filter: blur(2px);
        content: "";
      }

      @include iroha-vw-range($to: strip-unit($device-width--tab)) {
        min-width: $min-width;  // 1カラムの表示に必要な最低幅（px 値で指定, JS 側処理に必要）
        display: block;
        padding: $spacing--sp;
      }

      @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
        display: inline-block;
        padding: $spacing--pc;
      }

      @media print {
        position: relative !important;
        transform: none !important;
      }
    }

    &__title {
      position: relative;
      display: flex;
      align-items: center;
      padding: 0;

      @include iroha-vw-range($to: strip-unit($device-width--tab)) {
        margin: ($spacing--sp * 2) 0;
      }
      @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
        margin: $spacing--pc 0;
      }

      &:first-child {
        margin-top: 0;
      }
      &:last-child {
        margin-bottom: 0;
      }

      img {
        display: inline-block;
        width: auto;
        height: $size-unit * 16;
        margin: 0 ($size-unit * 5) 0 0;
        padding: 0;
        border: 1px solid #fff;
        border-radius: 100%;
        vertical-align: middle;
      }

      h1 {
        margin: 0;
        padding: 0;
        color: red;
        font-family: $font-family--fancy;
        font-size: $size-unit * 8;
        line-height: 1;
        text-shadow:  0px  4px 1px #fff,
                      1px  4px 1px #fff,
                      2px  4px 1px #fff,
                      3px  3px 1px #fff,
                      4px  2px 1px #fff,
                      4px  1px 1px #fff,
                      4px  0px 1px #fff,
                      4px -1px 1px #fff,
                      4px -2px 1px #fff,
                      3px -3px 1px #fff,
                      2px -4px 1px #fff,
                      1px -4px 1px #fff,
                      0px -4px 1px #fff,
                     -1px -4px 1px #fff,
                     -2px -4px 1px #fff,
                     -3px -3px 1px #fff,
                     -4px -2px 1px #fff,
                     -4px -1px 1px #fff,
                     -4px  0px 1px #fff,
                     -4px  1px 1px #fff,
                     -4px  2px 1px #fff,
                     -3px  3px 1px #fff,
                     -2px  4px 1px #fff,
                     -1px  4px 1px #fff,
                      0px  4px 1px #fff;
      }

      h1 > span,
      h1 > time {
        display: inline-block;
        white-space: nowrap;
      }

      h1 > time {
        display: none;  // experimental
        margin: ($size-unit * 3) 0 0 1em;
        font-size: $size-unit * 5;
      }
    }

    &__body {
      display: flex;
      flex-direction: row;
      position: relative;
      margin: 0;
      padding: 0;

      @include iroha-vw-range($to: strip-unit($device-width--tab)) {
        justify-content: space-between;
        flex-wrap: wrap;
      }
      @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
        justify-content: flex-start;
        flex-wrap: nowrap;
      }
    }

    &__col {
      flex-shrink: 0;
      display: block;
      width: $col-width;
      margin: 0;
      padding: 0;

      &:empty {
        display: none;
      }

      // col 同士の間隔
      @include iroha-vw-range($to: strip-unit($device-width--tab)) {
        &:not(:last-child) {
          margin-bottom: $spacing--sp * 2;
        }
      }
      $threshold: $device-width--sp + $spacing--sp;
      @include iroha-vw-range($from: strip-unit($threshold), $to: strip-unit($device-width--tab)) {
        &:not(:last-child) {
          margin-right: $spacing--sp;
        }
      }
      @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
        &:not(:last-child) {
          margin-right: $spacing--pc;
        }
      }

      // 幅を狭める（3 アイテムぶんの幅にする）場合
      &.-narrow {
        width: $col-width - ($item-width - $item-padding);

        // プレースホルダ扱いのアイテムは非表示
        ::v-deep .Item[hidden]:nth-child(4n) {
          display: none;
        }
      }
    }


    // ステータス表示の配置方法
    ::v-deep .Status {
      @include iroha-vw-range($to: strip-unit($device-width--tab)) {
        position: static;
      }
      @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
        position: absolute;
      }
    }
  }
</style>
